'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _class, _class2, _temp2;
// import { Link } from 'react-router';

// SearchHeaderMobile

// import iconFilter from './icon-filter.png';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _shops = require('redux/modules/shops');

var shopActions = _interopRequireWildcard(_shops);

var _address = require('redux/modules/address');

var addressActions = _interopRequireWildcard(_address);

var _setup = require('redux/modules/setup');

var setupActions = _interopRequireWildcard(_setup);

var _filter2 = require('redux/modules/filter');

var filterActions = _interopRequireWildcard(_filter2);

var _reactRedux = require('react-redux');

var _reduxAsyncConnect = require('redux-async-connect');

var _lodash = require('lodash');

var _lib = require('helpers/lib');

var _components = require('components');

var _reactBootstrap = require('react-bootstrap');

var _config = require('../../../config');

var _config2 = _interopRequireDefault(_config);

var _FilterMobile = require('./FilterMobile');

var _FilterMobile2 = _interopRequireDefault(_FilterMobile);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import checkedIcon from './checked.png';
// import icCheck from '../../../../static/icon/ic_check/ic_check.png';
// import icUncheck from '../../../../static/icon/ic_uncheck/ic_uncheck.png';
var iconSpaActive = '/cats/icon-spa.png';
var iconTatooActive = '/cats/icon-tatoo.png';
var iconHairActive = '/cats/icon-hair.png';
var iconFitnessActive = '/cats/icon-fitness.png';
var iconCosmeticActive = '/cats/icon-cosmetic.png';
var iconClinicActive = '/cats/icon-clinic.png';

var WAIT_INTERVAL = 100;
var seoInfos = {
  'cham-soc-da-massage': {
    title: 'Địa điểm chăm sóc da và massage tốt nhất',
    description: 'Địa điểm chăm sóc da và massage tốt nhất cùng hàng ngàn review, bình luận, và hình ảnh. Tìm kiếm chi tiết địa điểm trị mụn, trị sẹo thâm, nám, giúp trẻ hóa da, làm sạch và thanh tẩy. Địa điểm triệt lông, tắm trắng. Địa điểm massage mặt, massage body. Đặt lịch hẹn trước để tích điểm tại Lookme.vn'
  },
  'lam-toc-mong': {
    title: 'Địa điểm làm tóc và làm móng tốt nhất',
    description: 'Địa điểm làm tóc, làm móng tốt nhất cùng hàng ngàn review, bình luận, và hình ảnh. Tìm kiếm chi tiết địa điểm làm tóc, làm móng. Đặt lịch hẹn trước để tích điểm tại Lookme.vn'
  },
  'tham-my-vien': {
    title: 'Địa điểm thẩm mỹ viện tốt nhất',
    description: 'Địa điểm thẩm mỹ viện tốt nhất cùng hàng ngàn review, bình luận, và hình ảnh. Tìm kiếm chi tiết địa điểm thẩm mỹ viện làm mắt, mũi, mặt, ngực, bụng, miệng và giảm cân. Đặt lịch hẹn trước để tích điểm tại Lookme.vn'
  },
  'phong-kham': {
    title: 'Địa điểm phòng khám tốt nhất',
    description: 'Địa điểm phòng khám tốt nhất cùng hàng ngàn review, bình luận, và hình ảnh. Tìm kiếm chi tiết địa điểm phòng khám da, phòng khám răng. Đặt lịch hẹn trước để tích điểm tại Lookme.vn'
  },
  'the-duc-the-thao': {
    title: 'Địa điểm tập thể dục thể thao gym tốt nhất',
    description: 'Địa điểm tập thể dục thể thao tốt nhất cùng hàng ngàn review, bình luận, và hình ảnh. Tìm kiếm chi tiết địa điểm tập thể dục thể thao, tập yoga, tập gym, học nhảy dance, địa điểm hồ bơi. Đặt lịch hẹn trước để tích điểm tại Lookme.vn'
  },
  'xam-hinh': {
    title: 'Địa điểm xăm hình tốt nhất',
    description: 'Địa điểm xăm hình tốt nhất cùng hàng ngàn review, bình luận, và hình ảnh. Tìm kiếm chi tiết địa điểm xăm hình theo quận huyện thành phố. Đặt lịch hẹn trước để tích điểm tại Lookme.vn'
  }
};
var CategoryMobile = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState;

    var promises = [];
    if (!(0, _shops.isProminentLoaded)(getState())) {
      promises.push(dispatch((0, _shops.getProminent)()));
    }
    return _promise2.default.all(promises);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    shops: state.filter.data,
    total: state.filter.total,
    query: state.filter.query,
    categories: state.setup.categories,
    suggests: state.setup.suggests,
    categoriesFilter: state.setup.categoriesFilter,
    districts: state.address.districts,
    province: state.address.province,
    addressFilter: state.address.addressFilter,
    subCatFilter: state.setup.subCatFilter,
    loaded: state.filter.loaded,
    locationUser: state.user.coords,
    loading: state.filter.loading,
    flagSearch: state.filter.flagSearch,
    sort: state.filter.sort
  };
}, (0, _extends3.default)({}, shopActions, filterActions, addressActions, setupActions)), _dec(_class = _dec2(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(CategoryMobile, _Component);

  function CategoryMobile() {
    var _ref2;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, CategoryMobile);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = CategoryMobile.__proto__ || (0, _getPrototypeOf2.default)(CategoryMobile)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
      collapse: (0, _lib.initCollapse)(_this.props.categories),
      addressFilter: _this.props.addressFilter,
      subCatFilter: _this.props.subCatFilter,
      categoriesFilter: _this.props.categoriesFilter,
      query: _this.props.query,
      page_size: 12,
      showFilter: false,
      showSubFilter: false,
      currentFilterActive: '01',
      cat: 'cham-soc-da-massage',
      focus: false
    }, _this.handleChangeCurrentType = function (code) {
      _this.setState({
        currentFilterActive: code
      });
    }, _this.handleChangeMainCat = function (event) {
      var code = String(event.target.name);
      var categoriesFilter = _this.state.categoriesFilter;
      var subCatFilter = (0, _lodash.clone)(_this.state.subCatFilter);
      if (categoriesFilter[code] === 'none') {
        categoriesFilter[code] = 'all';
        // for (let index = 0; index < this.props.categories.length; index++) {
        //   if (this.props.categories[index].code === code) {
        //     const childrens = this.props.categories[index].childrens;
        //     for ( let jndex = 0; jndex < childrens.length; jndex++) {
        //       subCatFilter[code] = union(subCatFilter[code], [String(childrens[jndex].code)]);
        //     }
        //   }
        // }
      } else {
        categoriesFilter[code] = 'none';
        subCatFilter[code] = [];
      }
      _this.props.handleMainCat(categoriesFilter, subCatFilter);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(CategoryMobile, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.timer = null;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!this.props.loaded && this.props.loading !== true || !this.props.shops) {
        this.getResult.call(this);
      }
      var location = this.props.location;
      if (location && (location.pathname !== 'kham-pha' || location.query && location.query.category)) {
        this.initCategory.call(this, location);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var flag = false;
      if (this.props.flagSearch !== nextProps.flagSearch) {
        flag = true;
      }
      if (!(0, _lodash.isEqual)(nextProps.addressFilter, this.props.addressFilter)) {
        this.setState({ addressFilter: nextProps.addressFilter });
      }
      if (!(0, _lodash.isEqual)(nextProps.categoriesFilter, this.props.categoriesFilter)) {
        this.setState({ categoriesFilter: nextProps.categoriesFilter });
      }
      if (!(0, _lodash.isEqual)(nextProps.subCatFilter, this.props.subCatFilter)) {
        this.setState({ subCatFilter: nextProps.subCatFilter });
      }
      if (nextProps.sort !== this.props.sort) {
        flag = true;
        // this.setState({sort: nextProps.sort});
      }
      if (nextProps && nextProps.location && this.props.location) {
        if (nextProps.location.search !== this.props.location.search || nextProps.location.pathname !== this.props.location.pathname) {
          this.initCategory.call(this, nextProps.location);
        }
      }
      // if (nextProps.location !== this.props.locationUser) {
      //   flag = true;
      // }
      if (flag) {
        clearTimeout(this.timer);
        this.timer = setTimeout(this.getResult.bind(this), WAIT_INTERVAL);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.initCategory.call(this);
    }
  }, {
    key: 'onFilterClose',
    value: function onFilterClose() {
      this.setState({ showFilter: false });
    }
  }, {
    key: 'getResult',
    value: function getResult(filter) {
      var _filter = (0, _lib.processQuery)(this.state.query, this.props.province, this.props.addressFilter, this.props.categoriesFilter, this.props.subCatFilter, this.props.sort, this.props.locationUser);
      if (filter) {
        _filter = (0, _lib.processQuery)(this.state.query, this.props.province, filter.areasActive, filter.categoriesFilter, filter.subCatFilter, this.props.sort, this.props.locationUser);
      }
      this.props.getSearchResult(_filter);
    }
  }, {
    key: 'initCategory',
    value: function initCategory(location) {
      var _this2 = this;

      var catLink = [];
      if (location && location.pathname !== 'kham-pha') {
        catLink = [location.pathname.replace('/', '')];
      } else {
        catLink = location && location.query && location.query.category.split(',') || [];
      }
      var catCode = [];
      catLink.map(function (value) {
        for (var index = 0; index < _this2.props.categories.length; index++) {
          if (_this2.props.categories[index].link === value || _this2.props.categories[index].code === value) {
            // Tránh trường hợp code củ chạy không đúng
            catCode.push(_this2.props.categories[index].code);
          }
        }
      });
      this.setState({ cat: catLink[0], currentFilterActive: catCode[0] });
      var categoriesFilter = (0, _lodash.clone)(this.state.categoriesFilter);
      var subCatFilter = (0, _lodash.clone)(this.state.subCatFilter);
      for (var key in categoriesFilter) {
        if (categoriesFilter.hasOwnProperty(key)) {
          if (catCode.indexOf(key) !== -1) {
            categoriesFilter[key] = 'all';
          } else {
            categoriesFilter[key] = 'none';
            subCatFilter[key] = [];
          }
        }
      }
      this.props.handleMainCat(categoriesFilter, subCatFilter);
      this.props.changeFlag(!this.props.flagSearch);
    }
  }, {
    key: 'collapseHandle',
    value: function collapseHandle(code) {
      var collapse = this.state.collapse;
      collapse[code] = !collapse[code];
      this.setState({ collapse: collapse });
    }
  }, {
    key: 'handleSuggest',
    value: function handleSuggest(sort) {
      this.props.changeSortType(sort);
    }
  }, {
    key: 'clearCatFilter',
    value: function clearCatFilter() {
      var subCatFilter = (0, _lodash.clone)(this.state.subCatFilter);
      var categoriesFilter = (0, _lodash.clone)(this.state.categoriesFilter);
      for (var index = 0; index < this.props.categories.length; index++) {
        categoriesFilter[this.props.categories[index].code] = 'none';
        subCatFilter[this.props.categories[index].code] = [];
      }
      this.props.handleSubCat(subCatFilter, categoriesFilter);
    }
  }, {
    key: 'clearAddressFilter',
    value: function clearAddressFilter() {
      this.props.handleDistrictFilter([], '');
    }
  }, {
    key: 'clearQuery',
    value: function clearQuery() {
      this.props.changeQuery('');
    }
  }, {
    key: 'toggleFilter',
    value: function toggleFilter() {
      this.setState({
        showFilter: !this.state.showFilter
      });
    }
  }, {
    key: 'openFilter',
    value: function openFilter() {
      this.props.openFilter();
      this.setState({
        showFilter: true
      });
    }
  }, {
    key: 'closeFilter',
    value: function closeFilter() {
      this.props.closeFilter();
      this.setState({
        showFilter: false
      });
    }
  }, {
    key: 'toggleSubFilter',
    value: function toggleSubFilter() {
      this.setState({
        showSubFilter: !this.state.showSubFilter
      });
    }
  }, {
    key: 'handleCategory',
    value: function handleCategory(cat) {
      // TODO 1: gắng main subcat. Kiểm tra trạng thái của sub con.
      var categoriesFilter = (0, _lodash.clone)(this.state.categoriesFilter);
      var subCatFilter = (0, _lodash.clone)(this.state.subCatFilter);
      for (var key in categoriesFilter) {
        if (key === cat.code) {
          categoriesFilter[key] = 'all';
        } else {
          categoriesFilter[key] = 'none';
          subCatFilter[key] = [];
        }
      }
      this.props.handleMainCat(categoriesFilter, subCatFilter);
      // TODO 3: trạng thái giao diện render everything.
      this.setState({ currentFilterActive: cat.code });
      this.toggleSubFilter();
    }
  }, {
    key: 'handleRemoveCategory',
    value: function handleRemoveCategory(cat) {
      var categoriesFilter = (0, _lodash.clone)(this.state.categoriesFilter);
      var subCatFilter = (0, _lodash.clone)(this.state.subCatFilter);
      if (String(cat.code) === this.state.currentFilterActive) {
        this.setState({ currentFilterActive: '' });
        categoriesFilter[cat.code] = 'none';
        subCatFilter[cat.code] = [];
      }
      this.props.handleMainCat(categoriesFilter, subCatFilter);
      this.props.changeFlag(!this.props.flagSearch);
    }
  }, {
    key: 'handleRemoveSubCat',
    value: function handleRemoveSubCat(code) {
      var catActive = this.state.currentFilterActive;
      var categories = this.props.categories;

      var subCatFilter = (0, _lodash.clone)(this.state.subCatFilter);
      var categoriesFilter = (0, _lodash.clone)(this.state.categoriesFilter);
      var subsCat = [];
      if (subCatFilter[catActive].indexOf(code) === -1) {
        subsCat = (0, _lodash.union)(subCatFilter[catActive], [String(code)]);
      } else {
        subsCat = (0, _lodash.without)(subCatFilter[catActive], String(code));
      }
      if (subsCat.length === 0) {
        // TODO: bỏ hết subsCat
        this.setState({ currentFilterActive: '' });
      }
      subCatFilter[catActive] = subsCat;
      var flag = false;
      categories.map(function (v) {
        if (v.code === catActive && v.childrens.length === subsCat.length) {
          flag = true;
        }
      });
      if (flag === true) {
        categoriesFilter[catActive] = 'all';
      } else if (subsCat.length > 0) {
        categoriesFilter[catActive] = 'notAll';
      } else {
        categoriesFilter[catActive] = 'none';
      }
      this.props.handleMainCat(categoriesFilter, subCatFilter);
      this.props.changeFlag(!this.props.flagSearch);
    }
  }, {
    key: 'handleRemoveAddress',
    value: function handleRemoveAddress(code) {
      var addressFilter = this.state.addressFilter;

      var pFilter = [].concat((0, _toConsumableArray3.default)(addressFilter));
      var i = pFilter.indexOf(code);
      if (i !== -1) {
        pFilter = pFilter.filter(function (v) {
          return v !== code;
        });
      }
      this.props.changeAddress(pFilter);
      this.props.changeFlag(!this.props.flagSearch);
    }
  }, {
    key: 'onFocus',
    value: function onFocus() {
      this.setState({ focus: true });
    }
  }, {
    key: 'onBlur',
    value: function onBlur() {
      this.setState({ focus: false });
      document.activeElement.blur();
    }
  }, {
    key: 'getClass',
    value: function getClass(cls) {
      if (this.state.focus === true) {
        return cls;
      }
      return '';
    }
  }, {
    key: 'handleSubmit',
    value: function handleSubmit(filter) {
      // Hàm này được đẻ ra cho nút submit của filter nên làm thay đổi luồng cũ khá nhiều
      // Thứ 1: Submit mới thật sự thay đổi trạng thái của các filter: category, address, subcat.
      // Thứ 2: Chỉ gửi request một lần duy nhất.
      // Thứ 3: Đóng filter lại.
      // ==========
      // TODO 1: Thay đổi category.
      var catActive = filter.catActive,
          subsActive = filter.subsActive,
          areasActive = filter.areasActive;

      var categoriesFilter = (0, _extends3.default)({}, this.state.categoriesFilter);
      var subCatFilter = (0, _extends3.default)({}, this.state.subCatFilter);
      for (var key in categoriesFilter) {
        if (catActive === key) {
          categoriesFilter[key] = 'all';
          subCatFilter[key] = subsActive;
        } else {
          categoriesFilter[key] = 'none';
          subCatFilter[key] = [];
        }
      }
      // TODO 2: Thay đổi quận
      this.props.changeAddress(areasActive);
      this.props.handleMainCat(categoriesFilter, subCatFilter);
      var _filter = (0, _extends3.default)({}, filter, {
        categoriesFilter: categoriesFilter,
        subCatFilter: subCatFilter
      });
      // TODO 3: Set lại mặc định cho filter.
      // Set lại state làm giá trị mặc định cho filter.
      this.setState({ currentFilterActive: catActive });
      // TODO 4: Gửi request tìm kiếm và đóng filter.
      this.getResult.call(this, _filter);
      this.closeFilter();
    }
  }, {
    key: 'iconCat',
    value: function iconCat(code) {
      var styles = require('./DiscoverMobile.scss');
      switch (code) {
        case '01':
          return _react2.default.createElement('img', { className: styles.spa, src: iconSpaActive });
        case '02':
          return _react2.default.createElement('img', { className: styles.hair, src: iconHairActive });
        case '03':
          return _react2.default.createElement('img', { className: styles.cosmetic, src: iconCosmeticActive });
        case '04':
          return _react2.default.createElement('img', { className: styles.clinic, src: iconClinicActive });
        case '05':
          return _react2.default.createElement('img', { className: styles.fitness, src: iconFitnessActive });
        case '06':
          return _react2.default.createElement('img', { className: styles.tatoo, src: iconTatooActive });
        default:
          break;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          shops = _props.shops,
          categories = _props.categories,
          suggests = _props.suggests,
          districts = _props.districts,
          sort = _props.sort;
      var _state = this.state,
          addressFilter = _state.addressFilter,
          subCatFilter = _state.subCatFilter,
          categoriesFilter = _state.categoriesFilter,
          showFilter = _state.showFilter,
          currentFilterActive = _state.currentFilterActive;

      var styles = require('./DiscoverMobile.scss');
      var labelCats = (0, _lib.paserType)(categories, categoriesFilter);
      var labelAddress = (0, _lib.parseAddress)(districts, addressFilter);
      var labelSubCat = (0, _lib.parseSubCat)(categories, subCatFilter, currentFilterActive);
      var suggestsList = [];
      if (suggests && suggests.length > 0) {
        suggests.map(function (v, i) {
          return suggestsList.push(_react2.default.createElement(
            'div',
            {
              className: styles.label + ' ' + (sort !== undefined && sort === v.code ? styles.active : ''),
              key: 'suggest_' + i,
              onClick: function onClick() {
                return _this3.handleSuggest(v.code);
              }
            },
            v.label
          ));
        });
      }
      var meta = [];
      var seoInfo = seoInfos && seoInfos[this.state.cat] ? seoInfos[this.state.cat] : null;
      var title = seoInfo && seoInfo.title ? seoInfo.title : '';
      if (title) {
        meta.push({ property: 'og:title', content: title });
      }
      var url = location ? _config2.default.siteUrl + location.pathname : '';
      if (url) {
        meta.push({ property: 'og:url', content: url });
      }
      if (seoInfo && seoInfo.image) {
        meta.push({ property: 'og:image', content: seoInfo.image });
      }
      if (seoInfo && seoInfo.description) {
        meta.push({
          name: 'description',
          property: 'og:description',
          content: seoInfo.description
        });
      }
      var subsActive = [];
      if (currentFilterActive) {
        subsActive = subCatFilter[currentFilterActive];
      }
      return _react2.default.createElement(
        'div',
        {
          className: styles.discoverMobile + ' ' + this.getClass(styles.focus)
        },
        _react2.default.createElement(_reactHelmet2.default, { title: title, meta: meta }),
        _react2.default.createElement('div', {
          className: styles.bgCover,
          onClick: this.onBlur.bind(this),
          onTouchMove: this.onBlur.bind(this)
        }),
        _react2.default.createElement(
          'div',
          { className: styles.filterBar },
          _react2.default.createElement(
            'div',
            {
              className: styles.filterBtn + (showFilter ? ' ' + styles.btnFilterActive : ''),
              onClick: this.openFilter.bind(this)
            },
            _react2.default.createElement(
              'div',
              { className: styles.filterText },
              'B\u1ED9 L\u1ECDc'
            ),
            _react2.default.createElement(_reactBootstrap.Glyphicon, {
              className: styles.arrowDown,
              glyph: showFilter ? 'menu-up' : 'menu-down'
            })
          ),
          _react2.default.createElement(
            'div',
            { className: styles.slider },
            _react2.default.createElement(
              'div',
              { className: styles.sliderInside },
              _react2.default.createElement(
                'div',
                { className: styles.lType },
                labelCats && labelCats.length > 0 && labelCats.map(function (item, index) {
                  return _react2.default.createElement(
                    'div',
                    { className: styles.label, key: 'lType_' + index },
                    _this3.iconCat(item.code),
                    _react2.default.createElement(
                      'span',
                      { className: styles.text },
                      item.label
                    ),
                    _react2.default.createElement('span', {
                      className: styles.close,
                      onClick: function onClick() {
                        return _this3.handleRemoveCategory(item);
                      }
                    })
                  );
                }),
                labelSubCat && labelSubCat.length > 0 && labelSubCat.map(function (item, index) {
                  return _react2.default.createElement(
                    'div',
                    { className: styles.label, key: 'lType_' + index },
                    _react2.default.createElement(
                      'span',
                      null,
                      item.label
                    ),
                    _react2.default.createElement('span', {
                      className: styles.close,
                      onClick: function onClick() {
                        return _this3.handleRemoveSubCat(item.code);
                      }
                    })
                  );
                })
              ),
              _react2.default.createElement(
                'div',
                { className: styles.lAddress },
                labelAddress && labelAddress.length > 0 && labelAddress.map(function (item, index) {
                  return _react2.default.createElement(
                    'div',
                    { className: styles.label, key: 'lAddress_' + index },
                    _react2.default.createElement(
                      'span',
                      null,
                      item.label
                    ),
                    _react2.default.createElement('span', {
                      className: styles.close,
                      onClick: function onClick() {
                        return _this3.handleRemoveAddress(item.code);
                      }
                    })
                  );
                })
              )
            )
          )
        ),
        _react2.default.createElement(_FilterMobile2.default, {
          showFilter: this.state.showFilter,
          categories: this.props.categories,
          catActive: this.state.currentFilterActive,
          areasActive: this.state.addressFilter,
          subsActive: subsActive,
          closeFilter: this.closeFilter.bind(this),
          handleSubmit: this.handleSubmit.bind(this)
        }),
        _react2.default.createElement(
          'div',
          { className: styles.listCard },
          (!shops || shops.length === 0) && _react2.default.createElement(
            'div',
            { className: styles.noHistory },
            _react2.default.createElement(
              'div',
              { className: styles.textNoHistory },
              'Kh\xF4ng c\xF3 c\u1EEDa h\xE0ng n\xE0o ph\xF9 h\u1EE3p.'
            )
          ),
          shops && shops.map(function (shop, key) {
            return _react2.default.createElement(_components.CardMobile, { shop: shop, key: 'card_' + key });
          })
        )
      );
    }
  }]);
  return CategoryMobile;
}(_react.Component), _class2.propTypes = {
  shops: _react.PropTypes.array,
  total: _react.PropTypes.number,
  categories: _react.PropTypes.array,
  suggests: _react.PropTypes.array,
  districts: _react.PropTypes.array,
  addressFilter: _react.PropTypes.array,
  subCatFilter: _react.PropTypes.object,
  load: _react.PropTypes.func.isRequired,
  changeQuery: _react.PropTypes.func.isRequired,
  handleDistrictFilter: _react.PropTypes.func.isRequired,
  handleMainCat: _react.PropTypes.func.isRequired,
  handleSubCat: _react.PropTypes.func.isRequired,
  changeSortType: _react.PropTypes.func.isRequired,
  getSearchResult: _react.PropTypes.func.isRequired,
  openFilter: _react.PropTypes.func.isRequired,
  closeFilter: _react.PropTypes.func.isRequired,
  query: _react.PropTypes.string,
  province: _react.PropTypes.string,
  location: _react.PropTypes.object,
  categoriesFilter: _react.PropTypes.object,
  loaded: _react.PropTypes.bool,
  locationUser: _react.PropTypes.object,
  loading: _react.PropTypes.bool,
  flagSearch: _react.PropTypes.bool,
  changeFlag: _react.PropTypes.func,
  changeAddress: _react.PropTypes.func,
  sort: _react.PropTypes.string
}, _temp2)) || _class) || _class);
exports.default = CategoryMobile;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/CategoryMobile/CategoryMobile.js
// module id = 1541
// module chunks = 0